"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _runDispatchPipeline = _interopRequireDefault(require("./run-dispatch-pipeline"));

var _globals = require("../globals");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var buildReducer = function buildReducer(store, modules) {
  var Reducer = function Reducer(state, payload) {
    var reducerActions = {};
    store.map(function (storeItem) {
      reducerActions = _objectSpread(_objectSpread({}, reducerActions), {}, _defineProperty({}, storeItem.action, function () {
        return (0, _runDispatchPipeline["default"])(storeItem, state, payload, store, modules);
      }));
    });
    modules.map(function (module) {
      var _module$extendStore;

      (_module$extendStore = module.extendStore) === null || _module$extendStore === void 0 ? void 0 : _module$extendStore.data.map(function (storeItem) {
        reducerActions = _objectSpread(_objectSpread({}, reducerActions), {}, _defineProperty({}, storeItem.action, function () {
          return (0, _runDispatchPipeline["default"])(storeItem, state, payload, store, modules);
        }));
      });
    });

    try {
      return reducerActions[payload.type]();
    } catch (err) {
      throw Error("".concat(_globals.trebleError, " Store action key \"").concat(payload.type, "\" does not exist"));
    }
  };

  return Reducer;
};

var _default = buildReducer;
exports["default"] = _default;
module.exports = exports.default;